module.exports = __webpack_public_path__ + "img/lupin.2565e49c.svg";